import axios from 'axios'
import api from './api'
import Vue from 'vue';
let Base64 = require('js-base64').Base64;
import { Toast } from 'vant';
import qs from "qs";
import i18n from '../i18n';
import { getLanguage } from '../common/language';
import { localizeApiMessage } from '../i18n/api-message';

Vue.use(Toast);
//创建axios实例对象
const  instance = axios.create({
    // baseURL: 'https://adminmanage.l-o-v-e.homes/api', //服务器地址
     baseURL: '/api', //服务器地址
    timeout: 5000, //默认超时时长
    withCredentials: true, 
})

//请求拦截器
instance.interceptors.request.use(config=>{
    const language = getLanguage();
    const backendLanguage = { ja: 'jp' }[language] || language;
    config.headers = {
        ...config.headers,
        lang: language,
        'think-lang': backendLanguage
    };
    if(config.method === "post"){
        config.headers = {
            ...config.headers,
            'content-type': 'application/x-www-form-urlencoded;charset=UTF-8', // 设置跨域头部
        }
    }
    if(localStorage.getItem('token')){
        config.headers = {
            ...config.headers, 
            'token': Base64.encode(localStorage.getItem('token')),
         
        }
    }
    return config
},err=>{
    return Promise.reject(err);
})

function decodeResponse(body) {
    if (!body || typeof body !== 'object' || Array.isArray(body) ||
        !/^\d+$/.test(String(body.code))) {
        throw new Error('Invalid API response');
    }
    const result = { ...body };
    // Localize notifications once for both legacy Toasts and newer error panels.
    // Do not rewrite payload data such as announcements or user-authored text.
    const originalMessage = result.msg;
    result.msg = localizeApiMessage(originalMessage, result.code);
    if (result.msg !== originalMessage) result.originalMsg = originalMessage;

    if (typeof result.data === 'string' && result.data !== '') {
        try {
            result.data = JSON.parse(Base64.decode(result.data));
        } catch (error) {
            // An empty or malformed error payload must not hide the business error.
            if (Number(result.code) === 200) throw error;
            result.data = null;
        }
    } else if (result.data === '' || result.data === undefined) {
        result.data = null;
    }
    return result;
}

function failure(key) {
    return { code: 0, msg: String(i18n.t(key)), data: null };
}

//封装axios请求方法，参数为配置对象
//option = {method,url,params} method为请求方法，url为请求接口，params为请求参数
async function requestHttp(option = {}) {
    let response;
    try {
        if (option.method === 'get' || option.method === 'delete') {
            response = await instance[option.method](api[option.url], { params: option.data });
        } else if (option.method === 'post' || option.method === 'put') {
            response = await instance[option.method](api[option.url], qs.stringify(option.data));
        } else {
            return failure('common.request_failed');
        }
    } catch (error) {
        if (!error.response) return failure('common.network_error');
        const body = error.response.data;
        if (body && Number(body.code) !== 200) {
            try { return decodeResponse(body); } catch (decodeError) { /* Use HTTP status below. */ }
        }
        return failure(error.response.status >= 500 ? 'common.server_error' : 'common.response_error');
    }

    try {
        return decodeResponse(response.data);
    } catch (error) {
        return failure('common.response_error');
    }
}

// These endpoints select content from the server's HttpOnly language cookie.
// Keep cookie updates ordered without delaying the local UI or ordinary reads.
const cookieLanguageReads = new Set(['sys_config', 'sys_get_notice_list', 'lottery_get_peilv']);
let languageSync = Promise.resolve();

async function http(option = {}) {
    if (option.url === 'replaceLang') {
        const request = languageSync.then(() => requestHttp(option))
            .catch(() => failure('common.network_error'));
        languageSync = request.then(() => undefined);
        return request;
    }
    if (cookieLanguageReads.has(option.url)) {
        let pending;
        do {
            pending = languageSync;
            await pending;
        } while (pending !== languageSync);
    }
    return requestHttp(option);
}

export default http

